<template>
    <section class="btcdirect-view">
        <slot name="header" />

        <main :class="!$slots.header ? 'header-placeholder-' + (headerPlaceholder ?? 'full') : null">
            <slot />
        </main>

        <footer v-if="$slots.footer">
            <slot name="footer" />
        </footer>

        <powered-by-btcdirect v-if="!configurationStore.instanceConfiguration.hideFooter" />
    </section>
</template>

<script lang="ts" setup>
import { useConfigurationStore } from '@btcdirect/stores';
import PoweredByBtcdirect from '../footer/powered-by-btcdirect.vue';

defineProps<{ headerPlaceholder?: 'full' | 'small' | 'none' }>();

const configurationStore = useConfigurationStore();
</script>

<style lang="scss" scoped>
@use '@@scss/flex';
@use '@@scss/variables';

.btcdirect-view {
    @include flex.flex(flex, column);
    flex-shrink: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;

    :deep(> header) {
        position: sticky;
        top: 0;
        z-index: 9;
    }

    > main {
        @include flex.resize(1);
        padding-left: clamp(1rem, 2.5vw, variables.$default-padding);
        padding-right: clamp(1rem, 2.5vw, variables.$default-padding);

        &,
        & :deep(form) {
            @include flex.flex(flex, column);
            row-gap: clamp(0.6875rem, 2.5vh, 1.25rem);
        }

        &:not([class*='header-placeholder']) {
            padding-top: 0;
        }

        &.header-placeholder {
            &-full {
                padding-top: variables.$header-height;
            }

            &-small {
                padding-top: variables.$default-padding;
            }

            &-none {
                padding-top: 0.8rem;
            }
        }
    }

    > footer {
        @include flex.flex(flex, column);
        padding-left: variables.$default-padding;
        padding-right: variables.$default-padding;
        padding-top: variables.$flexible-padding;
        padding-bottom: variables.$flexible-padding;
        row-gap: 1em;
    }

    &.slide,
    &.slide-reverse {
        &-enter-active,
        &-leave-active {
            > main[class*='header-placeholder'] {
                &:not(.header-placeholder-small) {
                    padding-top: variables.$header-height;
                }
            }
        }
    }
}
</style>
